<template>
    <v-col cols="12" class="pa-0 mt-2">     
        <v-row>
            <v-col cols="auto" class="py-0 pr-0 d-none d-sm-block">
                <v-img
                    :src="require('@/assets/img/icons/store/icon-avatar-shadow.png')"
                    height="86"
                    width="86"
                ></v-img>
            </v-col>
            <v-col class="text-start pl-md-0 align-self-center">
                <p class="text-h6 mb-0 line-height-100 font-weight-black">{{ $t('store.avatars')}}</p>
                <span class="font-weight-light d-none d-sm-block">{{ $t('store.all_avatars')}}</span>
            </v-col>
        </v-row>
        
        <v-row align="center" justify="space-between">
            <v-col
                cols="12"
                class="py-0 px-6"
                v-for="(row, h) in matrix"
                :key="'row-'+h"
            >
                <v-row
                    class="fill-height mb-12"
                    align="center"
                    justify="start"
                >
                    <v-col
                        class="customCols"
                        v-for="(avatarPack, k) in row"
                        :key="'avatarP-'+k"
                    >
                        <AvatarPack :avatarPack="avatarPack" v-on:favorite="verifyFavorite" v-on:toBuy="toBuy" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            style="height: 15vh"
            align="center"
            justify="center"
            v-if="!favoriteView && matrix.length>0"
        >
            <v-col cols="5" class="justify-self-end">
                <v-img
                    :src="require('../../assets/img/arrows/volver-figura.svg')"
                    elevation="0"
                    height="40px"
                    class="float-right"
                    contain
                    @click="previous"
                    v-if="currentPage > 0"
                >
                <p class="button-next-2-text-2">{{ $t('store.previous') }}</p>
                </v-img>
            </v-col>
            <v-col cols="2" class="px-0">
                <span class="page-number">
                    {{ (currentPage + 1) }}
                </span>
                <span class="page-total-number">
                    {{ $t('store.of') + totalPages }}
                </span>
            </v-col>
            <v-col cols="5">
                <v-img
                    :src="require('../../assets/img/arrows/avanzar-figura.svg')"
                    elevation="0"
                    contain
                    height="40px"
                    class="float-left"                    
                    @click="next"
                    v-if="currentPage + 1 < totalPages"
                >
                    <p class="button-next-2-text-1">{{ $t('store.next') }}</p>
                </v-img>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>

import { mapState } from 'vuex'
import AvatarPack from './AvatarPack.vue'
import AvatarPackService from '../../services/avatarPack'
import UserAvatarService from '../../services/userAvatar'
import AvatarFavoriteService from '../../services/avatarFavorite'

export default {
    props: {
        favoriteView: { type: Boolean, default: false },
        reload: { type: Number, default: 0 },
        search: { type: String, default: '' }
    },
    components: {
        AvatarPack
    },
    data() {
        return {
            avatarPacks: [],
            currentPage: 0,
            favorites: null,
            purchases: null,
            totalPages: 0
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        matrix() {
            if (!this.purchases) {
                return this.listToMatrix([], 1)
            }
            if (!this.favorites) {
                return this.listToMatrix([], 1)
            }
            const avatars = this.avatarPacks.filter( (item) => {
                return item.avatarDTOList.length.toString().includes(this.search) || item.price.toString().includes(this.search)
            })
            // Verify purchase
            const storeAvatarPacks = []
            avatars.forEach(elementFromList => {
                const avatarPackFromList = elementFromList
                avatarPackFromList.purchased = this.purchases.some(elementFromPurchased => {
                    return elementFromPurchased.id === elementFromList.id
                })
                storeAvatarPacks.push(avatarPackFromList)
            });
            // Verify favorite
            const storeAvatarPacksFavoriteFilter = []
            storeAvatarPacks.forEach(elementFromList => {
                const avatarPackFromList = elementFromList
                avatarPackFromList.favorite = this.favorites.some(elementFromPurchased => {
                    return elementFromPurchased.id === avatarPackFromList.id
                })
                storeAvatarPacksFavoriteFilter.push(avatarPackFromList)
            });
            // Verify favorite view
            let finalArray = storeAvatarPacksFavoriteFilter
            if (this.favoriteView) {
                finalArray = storeAvatarPacksFavoriteFilter.filter( (item) => item.favorite === true)
            }
            if (this.$vuetify.breakpoint.xs) {
                return this.listToMatrix(finalArray, 3)
            }
            if (this.$vuetify.breakpoint.sm) {
                return this.listToMatrix(finalArray, 3)
            }
            if (this.$vuetify.breakpoint.md) {
                return this.listToMatrix(finalArray, 4)
            }
            if (this.$vuetify.breakpoint.lg) {
                return this.listToMatrix(finalArray, 6)
            }
            if (this.$vuetify.breakpoint.xl) {
                return this.listToMatrix(finalArray, 6)
            }
            return this.listToMatrix(finalArray, 4)
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        getActiveAvatars() {
            AvatarPackService.getPage(this.currentPage, 15)
                .then((response) => {
                    this.totalPages = response.content.totalPages
                    this.setPayAvatars(response.content.content)
                })
                .catch((error) => console.error(error))
        },
        getFavorites() {
            this.$emit('loaded', false)
            this.favorites = null
            AvatarFavoriteService.getAllByUser(
                this.user.id
            )
            .then((response) => {
                this.$emit('loaded', true)
                this.favorites = response.content
            })
            .catch((error) => console.error(error))
        },
        getUserAvatarPacks() {
            UserAvatarService.getAllPackByUser(
                this.user.id
            )
            .then((response) => {
                this.purchases = response.content
            })
            .catch((error) => console.error(error))
        },
        listToMatrix(list, elementsPerSubArray) {
            const matrix = []
            let i
            let k

            for (i = 0, k = -1; i < list.length; i+=1) {
                if (i % elementsPerSubArray === 0) {
                    k+=1;
                    matrix[k] = [];
                }
                matrix[k].push(list[i])
            }
            return matrix
        },
        async loadData() {
            await this.getFavorites()
            await this.getUserAvatarPacks()
            await this.getActiveAvatars()
        },
        next() {
            if (this.currentPage < (this.totalPages - 1)) {
                this.currentPage += 1
                this.avatarPacks = []
                this.getActiveAvatars()
            }
        },
        previous() {
            if (this.currentPage > 0) {
                this.currentPage -= 1
                this.avatarPacks = []
                this.getActiveAvatars()
            }
        },
        verifyFavorite(data) {
            const currentFavorites = JSON.parse(JSON.stringify(this.favorites))
            this.favorites = null
            setTimeout(() => {
                this.filterFavorite(data, currentFavorites)
            }, 500)
        },
        filterFavorite(data, currentFavorites) {
            const favorites = currentFavorites
            if (data.favorite) {
                favorites.push( { id: data.id } )
                this.favorites = favorites
            } else {
                this.favorites = favorites.filter( (item) => item.id !== data.id )
            }
        },
        setPayAvatars(data) {
            this.avatarPacks = data.filter( (item) => item.avatarPackType === 'PAY')
        },
        toBuy (avatarPack) {
            this.avatarPacks.forEach((avatarPackInList) => {
                if (avatarPackInList.id === avatarPack.id) {
                    this.$emit('purchase', avatarPack)
                }
            })
        }
    },
    watch: {
        reload() {
            this.getUserAvatarPacks()
            this.getFavorites()
        }
    }
}
</script>
<style scoped>
.customCols {
    width: 33%;
    max-width: 33%;
    flex-basis: 33%;
    padding-left: 0;
    padding-right: 0;
}
@media (min-width: 600px) {
    .customCols {
        width: 33%;
        max-width: 33%;
        flex-basis: 33%;
    }
}
@media (min-width: 960px) {
    .customCols {
        width: 25%;
        max-width: 25%;
        flex-basis: 25%;
    }
}
@media (min-width: 1264px) {
    .customCols {
        width: 16.6%;
        max-width: 16.6%;
        flex-basis: 16.6%;
    }
}
@media (min-width: 1904px) {
    .customCols {
        width: 16.6%;
        max-width: 16.6%;
        flex-basis: 16.6%;
    }
}

.button-next-2-text-1 {
    color: white;
    cursor: pointer;
    font-size: 1em;
    height: 100%;
    line-height: 40px;
}
.button-next-2-text-2 {
    color: #514585;
    cursor: pointer;
    font-size: 1em;
    height: 100%;
    line-height: 40px;
    margin-bottom: 0;
}
.page-number {
    font-size: 1em;
}
.page-total-number {
    color: #51458596;
    font-size: 1em;
}

/* @media (max-width: 1263px) {
    .button-next-2-text-1 {
        font-size: 3vw;
    }
    .button-next-2-text-2 {
        font-size: 3vw;
    }
    .page-number {
        font-size: 3vw;
    }
    .page-total-number {
        font-size: 3vw;
    }
} */
</style>